import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface ISearchSuggestion{
    name:string,
    location:string,
    mobile:string
}
const initialState:ISearchSuggestion={
    name:"",
    location:"",
    mobile:""

}
const searchSuggestion=createSlice({
    name:'searchsuggestion',
    initialState: initialState,
    reducers:{
        setSearchKeywords:(state,action:PayloadAction<{type:string,value:string}>)=>{
            if(action.payload.type==='name'){
                state.name=action.payload.value;
            }else if(action.payload.type==='location'){
                state.location=action.payload.value;
            }else if(action.payload.type==='mobile'){
                state.mobile=action.payload.value;
            }
        }
    }
})
export const {setSearchKeywords} = searchSuggestion.actions;
export default searchSuggestion.reducer;